var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoolean(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#E8F8FF",
    stroke: "#A1E2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78711 4V6.12109C7.78711 6.36719 7.7793 6.61133 7.76367 6.85352C7.75195 7.0957 7.73633 7.2832 7.7168 7.41602H7.78711C7.95898 7.14648 8.19336 6.91797 8.49023 6.73047C8.78711 6.53906 9.17188 6.44336 9.64453 6.44336C10.3789 6.44336 10.9746 6.73047 11.4316 7.30469C11.8887 7.87891 12.1172 8.7207 12.1172 9.83008C12.1172 10.5762 12.0117 11.2031 11.8008 11.7109C11.5898 12.2148 11.2949 12.5957 10.916 12.8535C10.5371 13.1074 10.0977 13.2344 9.59766 13.2344C9.11719 13.2344 8.73828 13.1484 8.46094 12.9766C8.18359 12.8047 7.95898 12.6113 7.78711 12.3965H7.66406L7.36523 13.1172H6V4H7.78711ZM9.07031 7.87305C8.75781 7.87305 8.50977 7.9375 8.32617 8.06641C8.14258 8.19531 8.00781 8.38867 7.92188 8.64648C7.83984 8.9043 7.79492 9.23047 7.78711 9.625V9.81836C7.78711 10.4551 7.88086 10.9434 8.06836 11.2832C8.25586 11.6191 8.59766 11.7871 9.09375 11.7871C9.46094 11.7871 9.75195 11.6172 9.9668 11.2773C10.1855 10.9375 10.2949 10.4473 10.2949 9.80664C10.2949 9.16602 10.1855 8.68359 9.9668 8.35938C9.74805 8.03516 9.44922 7.87305 9.07031 7.87305Z",
    fill: "#15A6E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoolean);
export default __webpack_public_path__ + "static/media/boolean.81caf5fc361ed6a70c4c4cbc6a4210c2.svg";
export { ForwardRef as ReactComponent };